import {ref, computed, watch} from '@vue/composition-api'
import {useToast} from 'vue-toastification/composition'
import ToastificationContent
  from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import router from "@/router";
import ability from '@/libs/acl/ability'
import {debounce} from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const refListTable = ref(null)
  const toast = useToast()

  const tableColumns = [
    {
      label: 'dmp.description',
      key: 'description',
      sortable: false
    },
    {
      label: 'dmp.eventDefinition',
      key: 'event_definition',
      sortable: false
    },
    {
      label: 'dmp.eventType',
      key: 'event_type',
      sortable: false
    },
    {
      label: 'dmp.deviceType',
      key: 'device_type',
      sortable: false
    },
    {
      label: 'dmp.deviceId',
      key: 'device_id',
      sortable: false
    },
    {
      label: 'dmp.deviceName',
      key: 'device_name',
      sortable: false
    },
    {
      label: 'dmp.deviceType',
      key: 'device_type',
      sortable: false
    },
    {
      label: 'dmp.userId',
      key: 'user_id',
      sortable: false
    },
    {
      label: 'dmp.username',
      key: 'user_name',
      sortable: false
    },
    {
      label: 'dmp.panel',
      key: 'panel.name',
      sortable: false
    },
    {
      label: 'dmp.alarmId',
      key: 'id_alarm',
      sortable: false
    },
    {
      label: 'dmp.typeAlarm',
      key: 'alarm_type',
      sortable: false
    },
    {
      label: 'dmp.eventDate',
      key: 'event_created_at',
      sortable: false
    }
  ]

  /* if (ability.can('update', 'DmpActions') || ability.can('delete', 'DmpActions')) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })
  } */

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('event_created_at')
  const isSortDirDesc = ref(true)
  const idPanel = router.currentRoute.params.id_panel;

  store.dispatch('dmp_panels/getAll')
  store.dispatch('type_alarm/getAll')
  store.dispatch('dmp_events_definition/getAll')

  const eventCode = ref([])
  const eventDefinitionOptions = computed(() => store.getters['dmp_events_definition/getSelectedItems'])

  const typeAlarm = ref([])
  const alarmTypeOptions = computed(() => store.getters['type_alarm/getSelectedItems'])
  const panelOptions = computed(() => store.getters['dmp_panels/getSelectedItems'])

  const eventDefinitionOptionsFilter = ref(null);
  const eventCodeFilter = ref(null)
  const typeAlarmFilter = ref(null)
  const dispatchAlarmFilter = ref(null)
  const valueFilter = ref(null)
  const idDmpProfile = ref(parseInt(router.currentRoute.params.id_dmp_profile))
  const panelFilter = ref(null)
  const startDatetimeFilter = ref(null)
  const endDatetimeFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.$refs.refTable.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    store.dispatch('dmp_alarms/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      event_definition: eventDefinitionOptionsFilter.value,
      event_type: eventCodeFilter.value,
      id_type_alarm: typeAlarmFilter.value,
      id_dmp_panel: panelFilter.value,
      start_date: startDatetimeFilter.value,
      end_date: endDatetimeFilter.value
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const refetchData = () => {
    //refListTable.value.$refs.refTable.value.refresh()
    refListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({})
  const filtersCount = useFilterCounter(filters)

  const buildFilters = () => {
    filters.value = {
      id_type_alarm: typeAlarmFilter.value,
      event_definition: eventDefinitionOptionsFilter.value,
      event_type: eventCodeFilter.value,
      id_dpm_panel: panelFilter.value,
      start_date: startDatetimeFilter.value,
      end_date: endDatetimeFilter.value
    }

    refetchData()
  }

  const clearSearchFilters = () => {
    typeAlarmFilter.value = null;
    eventDefinitionOptionsFilter.value = null;
    eventCodeFilter.value = null;
    panelFilter.value = null;
    startDatetimeFilter.value = null;
    endDatetimeFilter.value = null;

    buildFilters()
  }

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,

    idPanel,
    eventCode,
    eventDefinitionOptions,
    eventDefinitionOptionsFilter,
    panelFilter,
    panelOptions,
    typeAlarm,
    alarmTypeOptions,
    startDatetimeFilter,
    endDatetimeFilter,
    eventCodeFilter,
    typeAlarmFilter,
    dispatchAlarmFilter,
    valueFilter,

    refetchData,
    clearSearchFilters,
    buildFilters,
    filtersCount,

    idDmpProfile
  }
}
